import { render, staticRenderFns } from "./twitter-link.vue?vue&type=template&id=d7abab7c&"
import script from "./twitter-link.vue?vue&type=script&lang=js&"
export * from "./twitter-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports